// import Loading from '@/components/Loading';
import React, { useContext } from 'react';
import Loading from '@/components/LoadingML/LoadingML';
import { BodyStyled } from './BodyStyled';
import { ThemeContext } from 'styled-components';
import NoData from '@/components/no_data_show/NoData';
import { isEmptyObject } from '@/utils/comUtil';

const Body = ({
  children,
  bizData,
  loading,
  padd,
  height,
  minHeight,
  tableIsShow = false,
}) => {
  const themeContext = useContext(ThemeContext);
  return (
    <BodyStyled
      theme={themeContext}
      style={{ height: height ?? 'calc(100%)' }}
      className="contentBox"
    >
      <Loading loading={loading}>
        {loading || tableIsShow ? (
          children
        ) : (
          <div
            className="bodyContent"
            style={{ padding: padd, minHeight: minHeight }}
          >
            {isEmptyObject(bizData) ? <NoData loading={loading} /> : children}
          </div>
        )}
      </Loading>
    </BodyStyled>
  );
};

export default Body;
